import {
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  BookingInfoSlotDefinitionDto,
  BookingInfoWeekDetailDto,
} from "../../../graphql/models/Booking";
import { useEffect, useState } from "react";
import { BookingRangeCollection } from "./booking_range";

export interface BookingDayProps {
  value: BookingInfoWeekDetailDto | undefined;
  title: string;
  showCopyCheck?: boolean;
  onChange: (value: BookingInfoWeekDetailDto) => void;
  switchCopyCheck?: (value: boolean) => void;
}

export function BookingDay(props: BookingDayProps) {
  const { value, showCopyCheck } = props;
  const [allDay, setAllDay] = useState(value?.allDay ?? false);
  const [ranges, setRanges] = useState(value?.ranges ?? []);
  const [units, setUnits] = useState(value?.maxUnits ?? 0);
  const [hasChanges, setHasChanges] = useState(false);
  const [copyCheck, setCopyCheck] = useState(false);

  const handleUnitsChange = (value: string) => {
    setUnits(parseInt(value));
    setHasChanges(true);
  };

  const handleAllDayChange = (value: boolean) => {
    setAllDay(value);
    setHasChanges(true);
  };

  const handleRangesChange = (value: BookingInfoSlotDefinitionDto[]) => {
    setRanges(value);
    setHasChanges(true);
  };

  const handleSubmit = () => {
    const v = {
      allDay,
      ranges,
      maxUnits: units,
    };
    console.debug(`calling onChange with `, v);
    props.onChange(v);
    setHasChanges(false);
  };

  const handleCopyCheck = (value: boolean) => {
    if (props.switchCopyCheck) {
      setCopyCheck(value);
      props.switchCopyCheck(value);
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant={"h6"} align="center">
          {props.title}
        </Typography>
        <TextField
          label="Max persone/prenotazioni"
          type="number"
          variant={"outlined"}
          style={{ width: "50%" }}
          value={units}
          onChange={(e) => handleUnitsChange(e.target.value)}
        />
        <Checkbox
          checked={allDay}
          onChange={(e, value) => handleAllDayChange(value)}
        ></Checkbox>{" "}
        Aperto 24/24
        <br />
        <BookingRangeCollection
          disabled={allDay}
          value={ranges}
          onChange={handleRangesChange}
        ></BookingRangeCollection>
      </CardContent>
      <CardActions>
        {showCopyCheck && (
          <>
            <Checkbox
              checked={copyCheck}
              onChange={(e, v) => handleCopyCheck(v)}
            ></Checkbox>
            Copia!
          </>
        )}
        <Button
          type="button"
          disabled={!hasChanges}
          onClick={handleSubmit}
          variant={"outlined"}
          color={"primary"}
          style={{ backgroundColor: "lightgray", width: "40%" }}
        >
          Conferma
        </Button>
      </CardActions>
    </Card>
  );
}
